import axios from 'axios';

const instance = axios.create({
  timeout: 10000,
});

const buscarCep = async (cep) => {
  return instance.get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
};

const buscarCepWebmania = async (cep) => {
  return instance.get(`https://webmaniabr.com/api/1/cep/${cep}/?app_key=asldQpKaXJYgGylt9DE62G2jMgIU4PUZ&app_secret=61wp5FzIaRUA2D2Fj49fRBKXqazt8klhjKxMygGYFKCH8mij`);
}

export default {
  buscarCep,
  buscarCepWebmania,
};
